import React, { PureComponent } from 'react'

const withSorting = WrappedComponent => {
  return class extends PureComponent {
    state = {
      order: '',
      orderBy: '',
    }

    requestSortHandler = (e, property) => {
      const orderBy = property;
      let order = 'desc';

      if (this.state.orderBy === property && this.state.order === 'desc') {
        order = 'asc';
      }

      this.setState({ order, orderBy });
    }

    onSortResetClickHandler = () => {
      this.setState({
        order: '',
        orderBy: '',
      })
    }

    render() {
      const { order, orderBy } = this.state;

      return (
        <WrappedComponent 
          order={order}
          orderBy={orderBy}
          requestSortHandler={this.requestSortHandler}
          onSortResetClickHandler={this.onSortResetClickHandler}
          {...this.props}
        />
      )
    }
  }
}

export default withSorting


// WEBPACK FOOTER //
// ./src/hoc/withSorting/index.js